module.exports = "./dist/dmap/leaflet/layers.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/layers.png
// module id = 101
// module chunks = 0